import { render, staticRenderFns } from "./ObjectsGroup.vue?vue&type=template&id=260bd01e"
import script from "./ObjectsGroup.vue?vue&type=script&lang=ts"
export * from "./ObjectsGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports